import { ENV } from '@qse/constants'
export const AuthRoutes = {
  newPassword: '/auth/new-password',
  termsOfService: '/terms-of-service',
  privacyPolicy: '/privacy-policy',
  login: '/auth/login',
  resetPassword: '/auth/reset-password',
  verification: '/auth/verification',
  register: '/auth/register',
  forgotPassword: '/auth/forgot-password',
  forgotPasswordConfirm: '/auth/forgot-password-confirm',
  completeRegistration: '/auth/complete-account',
  completeResellerRegistration: '/auth/complete-reseller-account',
  confirmEmail: '/auth/confirm-email',
  logout: '/auth/logout',
  twoFA: '/auth/2fa-setup',
  twoFAVerify: '/auth/2fa-verify',
  profile: '/profile',
  qpa: ENV.QPA_URL || 'qpa',
} as const

export enum AppRoutesList {
  // Auth routes
  newPassword = '/auth/new-password',
  termsOfService = '/terms-of-service',
  privacyPolicy = '/privacy-policy',
  login = '/auth/login',
  resetPassword = '/auth/reset-password',
  verification = '/auth/verification',
  register = '/auth/register',
  forgotPassword = '/auth/forgot-password',
  forgotPasswordConfirm = '/auth/forgot-password-confirm',
  completeRegistration = '/auth/complete-account',
  completeResellerRegistration = '/auth/complete-reseller-account',
  confirmEmail = '/auth/confirm-email',
  logout = '/auth/logout',
  twoFA = '/auth/2fa-setup',
  twoFAVerify = '/auth/2fa-verify',
  profile = '/profile',
  accountDeletion = '/account-deletion',
  // Dashboard routes (shared between dashboard and admin)
  dashboard = '/dashboard',
  trash = '/dashboard/trash',
  generateEntropy = '/dashboard/generate-entropy',
  generateKeys = '/dashboard/generate-keys',
  favorites = '/dashboard/favorites',
  searchResults = '/dashboard/search-results',
  folder = '/folders/:id',
  reseller = '/dashboard/management/reseller',
  // Admin-specific routes
  tenant = '/dashboard/management/tenant/:id',
  users = '/dashboard/management/users',
  plan = '/dashboard/management/plan',
  managementSubscription = '/dashboard/management/subscription',
  storageReport = '/dashboard/management/storage-report',
  tenantAnalytics = '/dashboard/management/tenant-analytics/:tenantId',

  // Billing routes
  billing = '/billing',
  success = '/billing/success',
  error = '/billing/error',
}
